<template>
  <YContainer>
    <z-breadcrumb
      :items="[
        { text: 'Página inicial', url: 'https://querobolsa.com.br/' },
        { text: 'Programas do Governo', url: 'https://querobolsa.com.br/programas-do-governo' },
        { text: 'Dúvidas e Perguntas Frequentes' },
      ]"
    />

    <FinancialAidArticle :page="page" />

    <MontillaSlot slug="enem-page-bottom" />
  </YContainer>
</template>

<script>
import { YContainer } from '@quero/yeti'

import { retry } from '~/assets/js/utils/http'
import FinancialAidArticle from '~/components/financial-aid-article'
import MontillaSlot from '~/components/montilla-slot'
import hotjarMixin from '~/mixins/hotjar'

export default {
  name: 'EnemFaq',

  components: {
    MontillaSlot,
    FinancialAidArticle,
    YContainer,
  },

  mixins: [
    hotjarMixin,
  ],

  async asyncData ({ $cms, error }) {
    const params = {
      filter: {
        path: {
          _eq: '/enem/faq',
        },
      },
    }

    const request = await retry(
      () => $cms.$get('/items/FinancialAidPages', { params }),
      { retries: 6 },
    ).catch((err) => {
      error({ statusCode: 500, message: 'Failed to fetch content.\n' + err.message })
    })

    return {
      page: Object.freeze(request?.data[0]),
    }
  },

  data () {
    return {
      page: {
        title: '',
        content: [],
        sidebar: [
          {
            links: [],
          },
        ],
      },
    }
  },

  head () {
    return {
      title: this.page.headTitle,
      meta: this.page.headMeta || [],
      link: this.page.headLink,
    }
  },

  mounted () {
    window.montilla.track('content_view', {
      content_view_name: 'enem-faq',
      hotjar_sample: this.hotjarSample,
    })
  },
}
</script>
